import { render, staticRenderFns } from "./paba-signatures.vue?vue&type=template&id=1238c921&scoped=true&lang=pug"
import script from "./paba-signatures.vue?vue&type=script&lang=js"
export * from "./paba-signatures.vue?vue&type=script&lang=js"
import style0 from "./paba-signatures.vue?vue&type=style&index=0&id=1238c921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238c921",
  null
  
)

export default component.exports